const BookConsultation = 'BookConsultation';
const ContactSupport = 'ContactSupport';

export { BookConsultation, ContactSupport };
